module.exports = __webpack_public_path__ + "assets/img/key-success-story.ed87f7ac.webp";